module.exports = __webpack_public_path__ + "img/cameraBlue.8664b0e9.svg";